import React from 'react'
import { MapContainer, TileLayer,Marker,Popup} from 'react-leaflet'
function Map() {
    const markers=[{
        id:"1",
        name:"ENSA DE THIES",
        coords:
          [14.797401, -16.952362],
          link:"https://www.univ-thies.sn/index.php/offre-de-formation-ensa"
        
      },{
        id:"2",
        name:"Université Amadou Makhtar Mbow de Dakar",
        coords:
          [14.7070, -17.4695],
        link:"https://www.uam.sn/formation/ecole-superieure-des-sciences-agricoles-et-de-lalimentation-es2a"
        
      },
      {
        id:"3",
        name:"ISM",
        coords:[14.7170, -17.4695],
        link:"https://www.groupeism.sn/formation-management/bachelor-gestion-option-agrobusiness"
      },
      {
        id:"4",
        name:"ISEP THIES",
        coords:[14.797401, -16.522362],
        link:"https://www.isep-thies.sn/course/entrepreneuriat-agricole/"
      },{
        id:"5",
        name:"Université Gaston Berger",
        coords:[16.2, -14.922362],
        link:"https://www.ugb.sn/s2ata/"
      },
      {
        id:"6",
        name:"USSEIN",
        coords:[14.2, -15.922362],
        link:"https://www.ussein.sn/ufr-sciences-et-techniques-agronomie-et-production-vegetale/"
      },
      {
        id:"7",
        name:"ESAS",
        coords:[14.7470, -17.3695],
        link:"https://www.esasenegal.com"        
      }, {
        id:"8",
        name:"UPM Sénégal",
        coords:[14.7170, -17.4695],
        link:"https://upm.ac.ma/etudier-a-lupm/ingenierie/master-2-bac-5-agro-industrie-2/"        
      }
    ];
    
  return (
    <div>
         <MapContainer  center={[14.497401, -14.452362]} zoom={8} scrollWheelZoom={false}>
  <TileLayer
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  />
  
{ markers.map(
         (marker)=>(
            
              <Marker key={marker.id} position={marker.coords}>
                <Popup>
                   {marker.name}<br /> 
              <a href={marker.link}>Cliquez ici pour plus d'information</a>
                     
                   
                   
             </Popup>
            </Marker>
               
            
         )
    )}
</MapContainer>
    </div>
  )
}

export default Map